import React, { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CameraCropper from '../components/CameraCropper';
import { CheckInContext } from "../context/checkin";
import { dataURLtoBlob } from '../functions';
import { publish } from "../events";

const Camera = ({ code, onComplete }) => {
  const navigate = useNavigate();
  // const { idx } = useParams();
  // const { data: checkIn } = useContext(CheckInContext)

  let _title = 'Foto';
  let _desc = '';
  let _type = 'normal';
  // let _uploader = null;
  switch (code) {
    case 'selfie':
      _title = 'Foto de Rostro (selfie)'
      _desc = 'Tome la foto de su rostro, centrado en la cámara y en una distancia cercana';
      _type = 'selfie';
      // _uploader = uploadPassengerImage;
      break;
    case 'dniFront':
      _title = 'Foto DNI - Frente'
      _desc = 'Tome la foto de la parte frontal de su documento teniendo en cuenta que los textos sean legibles';
      // _uploader = uploadPassengerImage;
      break;
    case 'dniBack':
      _title = 'Foto DNI - Dorso'
      _desc = 'Tome la foto de la parte trasera de su documento teniendo en cuenta que los textos sean legibles';
      // _uploader = uploadPassengerImage;
      break;
  }
  
  useEffect(() => {
    
  }, [])

  if (typeof code === "undefined") return <p>code is required</p>

  return <CameraCropper 
      type={_type}
      title={_title}
      desc={_desc}
      onPhotoComplete={dataUrl => {
        if (onComplete) {
          onComplete.call(this, dataUrl)
        } else {
          console.log('onComplete trigger is null');
        }
        

        // setPassengersPhotos({ ...passengersPhotos, [code]: { ...passengersPhotos[code], uploading: true } });
        // if (onPassengersPhotosEventsCallback?.current) {
        //     onPassengersPhotosEventsCallback.current.call(this, { idx: idx, code: code, event: 'uploading', value: true })
        // }
        // publish("onPassengerPhoto", { code, value: dataUrl });
        // navigate(-1)
        // if (_uploader) {
        //   // _uploader(idx, imageCode, dataURLtoBlob(dataUrl))

        //   publish("onPassengerPhoto", { idx, code: imageCode });
        // }
        // dataUrl = dataURLtoBlob(dataUrl);
        // if (cameraMode == 'selfie') setSelfieToUpload(dataUrl);
        // if (cameraMode == 'dniFront') setDniFrontToUpload(dataUrl);
        // if (cameraMode == 'dniBack') setDniBackToUpload(dataUrl);
        // setCameraMode(false);
      }} 
      onClose={() => { navigate(-1) }}
    />;
}

export default Camera;